import { useEffect, useState } from 'react'
import { GetBasket } from '../Services/BasketService'
import { UserType } from '../Data/UserTypeEnum.ts'
import { useConfig } from '../Providers/ConfigProvider.jsx'
import { useAuth } from '../Providers/AuthProvider.jsx'
import axios from 'axios'
import { useDiscount } from '../Providers/DiscountProvider.jsx'

const useGetCart = () => {
    const { authState } = useAuth()
    const [cartItems, setCartItems] = useState({ basketItems: [], totalCostGross: 0, totalCostNet: 0, unavailableProductsIndexes: [] })
    const { api } = useConfig()
    const [isLoadingBasket, setIsLoadingBasket] = useState(false)
    const { voucher } = useDiscount()

    useEffect(() => {
        if (authState && authState.custId) {
            const source = axios.CancelToken.source()
            handleGetBasketStorage(source.token)
            return () => {
                source.cancel()
            }
        }
    }, [authState?.custId])

    const handleGetBasketStorage = async (cancelToken) => {
        if (authState.user && authState.custId && authState.siteId && authState.whId) {
            if (authState.user.userType === UserType.FerrodoUser) {
                setIsLoadingBasket(true)
                try {
                    let res = await GetBasket(api, authState.custId, authState.siteId, authState.whId, true, voucher, cancelToken)
                    setCartItems(res.data)
                    return true
                } catch (error) {
                    console.log(error)
                    return false
                }
                finally {
                    setIsLoadingBasket(false)
                }
            } else {
                setIsLoadingBasket(true)
                try {
                    let res = await GetBasket(api, authState.user.custId, authState.siteId, authState.whId, true, voucher, cancelToken)
                    setCartItems(res.data)
                    return true
                } catch (error) {
                    console.log(error)
                    return false
                }
                finally {
                    setIsLoadingBasket(false)
                }
            }
        }
    }

    const handleClearCartItems = () => {
        setCartItems(prev => {
            const safeItems = Array.isArray(prev?.basketItems) ? prev.basketItems.filter(i => !i.isSelected) : []
            return { ...prev, basketItems: safeItems }
        })
    }

    const handleDeleteAllItems = () => {
        setCartItems({ basketItems: [], totalCostGross: 0, totalCostNet: 0, unavailableProductsIndexes: [] })
    }



    return {
        cartItems,
        isLoadingBasket,
        setCartItems,
        handleGetBasketStorage,
        handleClearCartItems,
        handleDeleteAllItems,
    }
}

export default useGetCart